<template>
  <div class="row it-tour-page">
    <div class="col-md-12">
      <div class="card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
        <div class="card-content row">
          <!-- Top bar -->
          <div class="col-sm-12 mb-10 it-topbar">
            <!-- Company-level tour toggles (mirror the company details page). -->
            <div class="it-tour-settings">
              <label class="it-setting">
                <p-switch v-model="settings.use_interactive_tour_first_login" type="success"
                          @input="saveSettings('use_interactive_tour_first_login')"></p-switch>
                <span>{{ $t('settingsPages.interactiveTourFirstLogin') }}</span>
              </label>
              <label class="it-setting">
                <p-switch v-model="settings.use_interactive_tour_always" type="success"
                          @input="saveSettings('use_interactive_tour_always')"></p-switch>
                <span>{{ $t('settingsPages.interactiveTourAlways') }}</span>
              </label>
            </div>
            <div class="pull-right">
              <button class="btn add mar-bt-20" @click="openCreate">
                <img src="/static/img/icons/add.png">
                {{ $t('general.add') }}
              </button>
            </div>
          </div>

          <!-- Slides table -->
          <div class="col-sm-12">
            <div class="it-table-wrap">
            <table class="table width-table" ref="sortableTable">
              <thead>
                <tr>
                  <th width="5%"></th>
                  <th width="12%">{{ $t('marketingOffers.image') }}</th>
                  <th width="20%">{{ $t('marketingOffers.title') }}</th>
                  <th width="25%">Descriere</th>
                  <th width="13%">{{ $t('settingsPages.interactiveTourDisplayMode') }}</th>
                  <th width="8%">{{ $t('marketingOffers.status') }}</th>
                  <th width="9%">{{ $t('marketingOffers.actions') }}</th>
                  <th width="8%"></th>
                </tr>
              </thead>
              <draggable v-model="slides" :element="'tbody'" @end="onReorder">
                <template v-for="(item, index) in slides">
                  <tr class="sortableRow" :key="item.id">
                    <td>
                      <i style="cursor: move; color: #7C8DB5;" class="fa fa-arrows sortHandle"></i>
                    </td>
                    <td>
                      <img v-if="item.image_url" :src="item.image_url" class="it-thumb" />
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td>
                      <div class="it-clamp" :title="item.title">{{ item.title || '—' }}</div>
                    </td>
                    <td>
                      <div class="it-clamp" :title="item.description">{{ item.description || '—' }}</div>
                    </td>
                    <td>
                      <span class="it-mode-badge">{{ displayModeLabel(item.display_mode) }}</span>
                    </td>
                    <td>
                      <p-switch v-model="item.active" type="success" @input="handleActive(item)"></p-switch>
                    </td>
                    <td>
                      <a class="btn btn-danger btn-icon delete mar-rt-10" @click="handleDelete(index, item, $event)" :title="$t('general.delete')">
                        <img src="/static/img/icons/icon-close.png">
                        {{ $t('general.delete') }}
                      </a>
                    </td>
                    <td class="edit-icon-pointer" @click="openEdit(item)">
                      <div class="edit">
                        <i class="fa fa-pencil"></i>{{ $t('general.edit') }}
                      </div>
                    </td>
                  </tr>
                </template>
              </draggable>
            </table>
            </div>
            <p v-if="!loading && slides.length === 0" class="text-center mar-tp-20">
              Nicio secțiune adăugată încă.
            </p>
          </div>

          <!-- Add / Edit modal -->
          <vmodal name="tourModal"
                  class="tourModal"
                  width="95%"
                  :maxWidth="900"
                  :minWidth="300"
                  height="auto"
                  :scrollable="true"
                  :adaptive="true"
                  @opened="onModalOpened">
            <div class="header border-bottom">
              <h4>{{ form.id ? $t('general.edit') : $t('general.add') }} — Tur Interactiv</h4>
            </div>
            <div class="content-group">
              <div class="content_scrool">

                <!-- Image -->
                <div class="form-group">
                  <label>{{ $t('marketingOffers.image') }} <small class="text-muted">(max {{ MAX_IMAGE_PX }}x{{ MAX_IMAGE_PX }}px, max {{ MAX_IMAGE_MB }}MB)</small></label>
                  <el-upload
                    action=""
                    list-type="picture-card"
                    accept=".jpg,.jpeg,.png"
                    :file-list="form.imagelist"
                    :limit="1"
                    :auto-upload="false"
                    :on-change="handleImageChange"
                    :on-remove="handleImageRemove"
                    :on-exceed="handleExceed">
                    <img src="/static/img/icons/icon-plus-primary.png">
                  </el-upload>
                </div>

                <!-- Title -->
                <div class="form-group">
                  <label>{{ $t('marketingOffers.title') }}</label>
                  <input type="text" class="form-control" v-model="form.title" :maxlength="TITLE_MAX" />
                  <small class="text-muted pull-right">{{ (form.title || '').length }} / {{ TITLE_MAX }}</small>
                </div>

                <!-- Description -->
                <div class="form-group">
                  <label>Descriere</label>
                  <textarea class="form-control" rows="4" v-model="form.description" :maxlength="DESCRIPTION_MAX"></textarea>
                  <small class="text-muted pull-right">{{ (form.description || '').length }} / {{ DESCRIPTION_MAX }}</small>
                </div>

                <!-- Display mode -->
                <div class="form-group">
                  <label>{{ $t('settingsPages.interactiveTourDisplayMode') }}</label>
                  <select class="form-control" v-model="form.display_mode">
                    <option v-for="mode in DISPLAY_MODES" :key="mode" :value="mode">
                      {{ displayModeLabel(mode) }}
                    </option>
                  </select>
                </div>

                <p class="text-muted mar-tp-10">
                  Nimic nu e obligatoriu, dar o secțiune trebuie să aibă cel puțin o poză, un titlu sau o descriere.
                </p>

              </div>
            </div>
            <div class="tourModal__footer border-top" style="display: flex; align-items: center; justify-content: space-between;">
              <button type="button" class="btn btn-default mar-rt-10" @click="closeModal">
                {{ $t('general.cancel') }}
              </button>
              <button type="button" class="btn btn-success btn-icon save" :disabled="saving" @click="save" :title="$t('general.save')">
                <img src="/static/img/icons/save.png">
                {{ $t('general.save') }}
              </button>
            </div>
          </vmodal>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Upload } from 'element-ui'
  import draggable from 'vuedraggable'
  import vmodal from 'vue-js-modal'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(Upload)
  Vue.use(vmodal, { componentName: 'vmodal' })

  const TITLE_MAX = 35
  const DESCRIPTION_MAX = 180
  const MAX_IMAGE_MB = 5
  const MAX_IMAGE_PX = 900

  // Per-slide image display mode on the app slider (must match the API).
  const DISPLAY_MODES = ['contain', 'cover', 'full_page']
  const DISPLAY_DEFAULT = 'contain'

  export default {
    components: {
      draggable,
      PSwitch
    },
    data () {
      return {
        TITLE_MAX,
        DESCRIPTION_MAX,
        MAX_IMAGE_MB,
        MAX_IMAGE_PX,
        DISPLAY_MODES,
        loading: true,
        saving: false,
        slides: [],
        settings: {
          use_interactive_tour_first_login: false,
          use_interactive_tour_always: false
        },
        form: this.emptyForm()
      }
    },
    computed: {
      companyID () {
        return this.$session.get('selectedCompany')
      },
      token () {
        return this.$session.get('token')
      }
    },
    created () {
      this.initPage()
    },
    methods: {
      emptyForm () {
        return {
          id: null,
          title: '',
          description: '',
          display_mode: DISPLAY_DEFAULT,
          active: 1,
          imagelist: [],
          filename: null
        }
      },
      baseData (extra) {
        return Object.assign({
          token: this.token,
          company_id: this.companyID
        }, extra || {})
      },
      initPage () {
        this.loading = true
        this.getSettings()
        this.getSlides()
      },
      getSlides () {
        this.apiRequest('/interactive-tour', 'GET', this.baseData(), (response) => {
          if (response.status === true) {
            this.slides = response.data
          }
          this.$nextTick(() => { this.loading = false })
        })
      },
      getSettings () {
        // Separate call: the api() response macro only forwards status/errors/
        // data, so the company toggles can't ride alongside the slides array.
        this.apiRequest('/interactive-tour/settings', 'GET', this.baseData(), (response) => {
          if (response.status === true && response.data) {
            this.settings = {
              use_interactive_tour_first_login: !!response.data.use_interactive_tour_first_login,
              use_interactive_tour_always: !!response.data.use_interactive_tour_always
            }
          }
        })
      },
      /* ---------------- Company-level toggles ---------------- */
      displayModeLabel (mode) {
        const key = {
          contain: 'interactiveTourDisplayContain',
          cover: 'interactiveTourDisplayCover',
          full_page: 'interactiveTourDisplayFullPage'
        }[mode] || 'interactiveTourDisplayContain'
        return this.$t('settingsPages.' + key)
      },
      saveSettings (key) {
        const value = this.settings[key] ? 1 : 0
        const data = this.baseData({ [key]: value })
        this.apiRequest('/interactive-tour/settings', 'POST', data, (response) => {
          if (response.status !== true) {
            // Revert the toggle on failure.
            this.settings[key] = !this.settings[key]
            swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
          }
        })
      },
      /* ---------------- Modal open / close ---------------- */
      openCreate () {
        this.form = this.emptyForm()
        this.$modal.show('tourModal')
      },
      openEdit (item) {
        this.apiRequest('/interactive-tour/' + item.id, 'GET', this.baseData(), (response) => {
          if (response.status === true) {
            this.form = this.mapToForm(response.data)
            this.$modal.show('tourModal')
          } else {
            swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
          }
        })
      },
      closeModal () {
        this.$modal.hide('tourModal')
      },
      onModalOpened () {
        // `.main-panel` has a transform, which makes it the containing block for
        // this modal's `position: fixed` container. Re-parent it to <body> so it
        // stays viewport-fixed instead of sliding under the fixed sidebar.
        const el = document.querySelector('.tourModal.vm--container')
        if (el && el.parentNode !== document.body) {
          document.body.appendChild(el)
        }
      },
      mapToForm (data) {
        const form = this.emptyForm()
        form.id = data.id
        form.title = data.title || ''
        form.description = data.description || ''
        form.display_mode = DISPLAY_MODES.indexOf(data.display_mode) !== -1 ? data.display_mode : DISPLAY_DEFAULT
        form.active = data.active ? 1 : 0
        form.filename = data.image_filename || null
        form.imagelist = data.image_filename
          ? [{ url: data.image_url, name: data.image_filename, filename: data.image_filename }]
          : []
        return form
      },
      /* ---------------- Image handlers ---------------- */
      handleImageChange (file, fileList) {
        // Reject anything over 5MB straight away.
        if (this.isOversized(file)) {
          this.warnOversized()
          this.form.imagelist = fileList.filter(f => f.uid !== file.uid).slice(-1)
          return
        }

        // Then reject anything larger than MAX_IMAGE_PX x MAX_IMAGE_PX. Reading
        // the dimensions is async, so only commit the list once we know.
        const raw = file.raw
        if (!raw) {
          this.form.imagelist = fileList.filter(f => !this.isOversized(f)).slice(-1)
          return
        }

        this.checkDimensions(raw, (ok) => {
          if (!ok) {
            this.warnDimensions()
            // Drop the rejected file, keep any previously valid one.
            this.form.imagelist = fileList.filter(f => f.uid !== file.uid).slice(-1)
          } else {
            this.form.imagelist = fileList.filter(f => !this.isOversized(f)).slice(-1)
          }
        })
      },
      handleImageRemove () {
        this.form.imagelist = []
        this.form.filename = null
      },
      handleExceed () {
        swal('', 'Poți adăuga o singură poză.', 'warning').catch(() => {})
      },
      /**
       * Images already stored on the server carry no `size` (only a url), so
       * they must never be treated as oversized.
       */
      isOversized (file) {
        return !!(file && file.size && (file.size / 1024 / 1024) > MAX_IMAGE_MB)
      },
      /**
       * Read the real pixel dimensions of a freshly selected file and report
       * back whether both sides are within MAX_IMAGE_PX. If the file can't be
       * read as an image we don't block it (the server validates again).
       */
      checkDimensions (rawFile, onResult) {
        const url = window.URL.createObjectURL(rawFile)
        const img = document.createElement('img')
        img.onload = () => {
          const ok = img.naturalWidth <= MAX_IMAGE_PX && img.naturalHeight <= MAX_IMAGE_PX
          window.URL.revokeObjectURL(url)
          onResult(ok)
        }
        img.onerror = () => {
          window.URL.revokeObjectURL(url)
          onResult(true)
        }
        img.src = url
      },
      warnOversized () {
        swal({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).catch(() => {})
      },
      warnDimensions () {
        swal({
          toast: true,
          type: 'warning',
          text: 'Poza trebuie să fie de maxim ' + MAX_IMAGE_PX + 'x' + MAX_IMAGE_PX + 'px.',
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).catch(() => {})
      },
      /* ---------------- Payload builder ---------------- */
      async collectImage () {
        const f = this.form.imagelist && this.form.imagelist[0]
        if (!f) {
          return ''
        }
        if (f.raw) {
          return this.getBase64(f.raw)
        }
        if (f.filename) {
          return f.filename
        }
        return ''
      },
      /* ---------------- Save ---------------- */
      async save () {
        const title = (this.form.title || '').trim()
        const description = (this.form.description || '').trim()
        const hasImage = !!(this.form.imagelist && this.form.imagelist[0])

        // A slide must carry at least one of title / description / image.
        if (!title && !description && !hasImage) {
          swal('', 'Adaugă cel puțin o poză, un titlu sau o descriere.', 'warning').catch(() => {})
          return
        }

        if (title.length > TITLE_MAX) {
          swal('', 'Titlul poate avea maxim ' + TITLE_MAX + ' caractere.', 'warning').catch(() => {})
          return
        }

        if (description.length > DESCRIPTION_MAX) {
          swal('', 'Descrierea poate avea maxim ' + DESCRIPTION_MAX + ' caractere.', 'warning').catch(() => {})
          return
        }

        this.saving = true

        let image
        try {
          image = await this.collectImage()
        } catch (e) {
          this.saving = false
          swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
          return
        }

        const data = this.baseData({
          title: this.form.title,
          description: this.form.description,
          image: image,
          display_mode: this.form.display_mode || DISPLAY_DEFAULT,
          active: this.form.active ? 1 : 0
        })

        const isUpdate = !!this.form.id
        const url = isUpdate ? '/interactive-tour/' + this.form.id : '/interactive-tour'
        const method = isUpdate ? 'PUT' : 'POST'

        this.apiRequest(url, method, data, (response) => {
          this.saving = false
          if (response.status === true) {
            this.closeModal()
            this.getSlides()
            swal(this.$t('general.success') + '!', '', 'success').catch(() => {})
          } else {
            const msg = response.errors ? Object.values(response.errors)[0] : this.$t('validations.wentWrong')
            swal('', msg, 'error').catch(() => {})
          }
        })
      },
      /* ---------------- Active toggle ---------------- */
      handleActive (row) {
        const actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            const data = this.baseData({ active: row.active ? 1 : 0 })
            this.apiRequest('/interactive-tour/' + row.id, 'PUT', data, (response) => {
              if (response.status !== true) {
                row.active = !row.active
                swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
              }
            })
          } else {
            row.active = !row.active
          }
        }).catch(() => {
          row.active = !row.active
        })
      },
      /* ---------------- Reorder ---------------- */
      onReorder () {
        const order = this.slides.map(s => s.id)
        const data = this.baseData({ order: order })
        this.apiRequest('/interactive-tour/reorder', 'POST', data, (response) => {
          if (response.status !== true) {
            swal({
              title: '',
              text: this.$t('validations.dataCouldNotBeSaved'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            }).catch(() => {})
          }
        })
      },
      /* ---------------- Delete ---------------- */
      handleDelete (index, row, event) {
        const self = this
        if (event) event.stopPropagation()
        swal({
          text: self.$t('marketingCampaigns.areYouSureDelete') + ` '${row.title || ''}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        }).then((result) => {
          if (result) {
            this.apiRequest('/interactive-tour/' + row.id, 'DELETE', this.baseData(), (response) => {
              if (response.status === true) {
                self.slides.splice(index, 1)
                swal('', self.$t('general.success') + '!', 'success').catch(() => {})
              } else {
                swal('', self.$t('validations.wentWrong'), 'error').catch(() => {})
              }
            })
          }
        }).catch(() => {})
      }
    }
  }
</script>

<style scoped>
  .border-bottom {
    border-bottom: 1px solid #ccc;
  }
  .border-top {
    border-top: 1px solid #ccc;
  }
  .header {
    padding: 15px;
  }
  .tourModal >>> .vm--modal {
    top: 0 !important;
    left: 0 !important;
    width: 96% !important;
    max-width: 900px !important;
    max-height: 88vh !important;
    margin: 24px auto !important;
    display: flex;
    flex-direction: column;
  }
  .content-group {
    margin: 10px 15px;
    flex: 1 1 auto;
    overflow-y: auto;
    padding-bottom: 24px;
  }
  .tourModal__footer {
    padding: 15px;
    text-align: right;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  /* Top bar: company toggles on the left, Add button on the right. */
  .it-topbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .it-tour-settings {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 24px;
  }
  .it-setting {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    font-weight: 400;
    cursor: pointer;
  }
  .it-topbar .pull-right {
    margin-left: auto;
  }
  .it-mode-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    background: #eef1f7;
    color: #5a6a8a;
    font-size: 12px;
    white-space: nowrap;
  }
  .mar-tp-10 {
    margin-top: 10px;
  }
  .mar-tp-20 {
    margin-top: 20px;
  }
  .it-thumb {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 6px;
  }
  /* Title / description cells: clamp long text to 2 lines with an ellipsis. */
  .it-clamp {
    max-width: 420px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
  /* Slides table: scroll sideways instead of squashing on narrow screens. */
  .it-table-wrap {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .it-table-wrap > table {
    min-width: 800px;
  }
  /* Space after the whole card so the floating "new orders" widget has room. */
  .it-tour-page {
    padding-bottom: 150px;
  }
  @media (max-width: 600px) {
    .card-content .pull-right {
      float: none !important;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    .card-content .pull-right .btn {
      flex: 1 1 auto;
      margin-right: 0;
    }
    .content-group {
      margin: 10px;
    }
    .header,
    .tourModal__footer {
      padding: 10px;
    }
    .tourModal__footer .btn {
      display: block;
      width: 100%;
      margin: 0 0 8px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Online/InteractiveTour.vue